import { ConstructorRecommendationsResponseObject } from '../../constructorTypes'
import { SearchOptionLinksObject } from '../../types'
import { addStoreLocaleByCookie } from 'lib/storeLocale/client'

export const transformConstructorRecommendationsResults = (
  recommendationsResponse: ConstructorRecommendationsResponseObject | null
): ReadonlyArray<SearchOptionLinksObject> => {
  return (
    (recommendationsResponse?.results || []).map(({ value }) => ({
      label: value,
      link: addStoreLocaleByCookie(`/all?query=${encodeURIComponent(value)}`),
    })) || []
  )
}
